// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UserMarkerInfoWindow-module-infoWindowContentWrapper-27uuo{border-radius:0;background-color:#3567ff;background-color:var(--des-color-stroke-selected-element, #3567ff);padding-block:5px;padding-inline:15px}.UserMarkerInfoWindow-module-infoWindowText-3uWKi{color:var(--des-color-brand-content-legal-legal1);font-size:14px;line-height:23px;font-weight:var(--fonts-weight-bold)}", ""]);
// Exports
exports.locals = {
	"infoWindowContentWrapper": "UserMarkerInfoWindow-module-infoWindowContentWrapper-27uuo",
	"infoWindowText": "UserMarkerInfoWindow-module-infoWindowText-3uWKi"
};
module.exports = exports;
